import { DateConstraints } from '@/utils/campaignDateConstraints';
import {
    FormErrorMessage,
    PeriodDatePicker,
    Typography,
} from '@analytical-alley/ui';
import { FieldErrors } from 'react-hook-form';
import { CampaignFormData } from '../schema';

interface DatesStepProps {
    startDate: Date;
    endDate: Date;
    dateConstraints: DateConstraints;
    onDateChange: (startDate: Date, endDate: Date) => void;
    errors: FieldErrors<CampaignFormData>;
}

export const DatesStep = ({
    startDate,
    endDate,
    dateConstraints,
    onDateChange,
    errors,
}: DatesStepProps) => {
    return (
        <div className="w-full relative">
            <Typography variant="bodyS" className="mb-3 text-gray-500">
                Select the campaign flight period. <br/> The optimiser distributes
                spend across these dates and uses them to align media activity
                with the modelled date range.
            </Typography>
            <PeriodDatePicker
                startDate={startDate}
                endDate={endDate}
                minDate={dateConstraints.selectableMinDate}
                maxDate={dateConstraints.selectableMaxDate}
                visibleMinDate={dateConstraints.visibleMinDate}
                visibleMaxDate={dateConstraints.visibleMaxDate}
                minPeriodDays={10}
                maxPeriodDays={184}
                onDateChange={onDateChange}
                open
                showTrigger={false}
                autoApply
            />
            {errors.startDate && (
                <FormErrorMessage errors={errors as any} name="startDate" />
            )}
            {errors.endDate && (
                <FormErrorMessage errors={errors as any} name="endDate" />
            )}
        </div>
    );
};
